<template>
    <!-- <v-touch tag="div" @pinch="invalidPinch($event)" class="three-right"> -->
    <div class="three-right switchTarget">
        <div class="rightBody">
            <div
                v-if="mode === 'atBat'"
                class="viewPoints"
            >
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'pitcher'}"
                    @tap="setViewPointAndSinglePitch(0, 200, 0, 0, 70, 1844, 'pitcher')"
                >
                    <span
                        class="icon-angle-pitcher"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'batterRight'}"
                    @tap="setViewPointAndSinglePitch(80, 170, 1844, 0, 0, 0, 'batterRight')"
                >
                    <span
                        class="icon-angle-batter-right"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'batterLeft'}"
                    @tap="setViewPointAndSinglePitch(-80, 170, 1844, 0, 0, 0, 'batterLeft')"
                >
                    <span
                        class="icon-angle-batter-left"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === '1stBase'}"
                    @tap="setViewPointAndSinglePitch(1500, 100, 1022, 0, 100, 1022, '1stBase')"
                >
                    <span
                        class="icon-angle-1st-base"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === '3rdBase'}"
                    @tap="setViewPointAndSinglePitch(-1500, 100, 1022, 0, 100, 1022, '3rdBase')"
                >
                    <span
                        class="icon-angle-3rd-base"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'catcher'}"
                    @tap="setViewPointAndSinglePitch(0, 80, 2100, 0, 100, 0, 'catcher')"
                >
                    <span
                        class="icon-angle-catcher"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'overall'}"
                    @tap="setViewPointAndSinglePitch(0, 2600, 922, 0, 0, 922, 'overall')"
                >
                    <span
                        class="icon-angle-overall"
                    />
                </v-touch>
            </div>
            <div
                v-else
                class="viewPoints compare"
            >
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'pitcher'}"
                    @tap="setViewPointAndMultiPitch(0, 200, 0, 0, 70, 1844, 'pitcher')"
                >
                    <span
                        class="icon-angle-pitcher"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'batterRight'}"
                    @tap="setViewPointAndMultiPitch(80, 170, 1844, 0, 0, 0, 'batterRight')"
                >
                    <span
                        class="icon-angle-batter-right"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'batterLeft'}"
                    @tap="setViewPointAndMultiPitch(-80, 170, 1844, 0, 0, 0, 'batterLeft')"
                >
                    <span
                        class="icon-angle-batter-left"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === '1stBase'}"
                    @tap="setViewPointAndMultiPitch(1500, 100, 1022, 0, 100, 1022, '1stBase')"
                >
                    <span
                        class="icon-angle-1st-base"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === '3rdBase'}"
                    @tap="setViewPointAndMultiPitch(-1500, 100, 1022, 0, 100, 1022, '3rdBase')"
                >
                    <span
                        class="icon-angle-3rd-base"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'catcher'}"
                    @tap="setViewPointAndMultiPitch(0, 80, 2100, 0, 100, 0, 'catcher')"
                >
                    <span
                        class="icon-angle-catcher"
                    />
                </v-touch>
                <v-touch
                    tag="p"
                    class="viewPoint"
                    :class="{styleSelectedView: currentAngle === 'overall'}"
                    @tap="setViewPointAndMultiPitch(0, 2600, 922, 0, 0, 922, 'overall')"
                >
                    <span
                        class="icon-angle-overall"
                    />
                </v-touch>
            </div>
            <div v-if="mode !== 'tunnel'">
                <p
                    v-if="mode !== 'atBat' && (currentAngle === 'batterLeft' || currentAngle === 'batterRight')"
                    class="setting active"
                    @click="toggleBatterPanel()"
                >
                    打者設定
                </p>
                <!-- <p class="setting" v-else-if="mode !== 'atBat'">打者設定</p> -->
                <p
                    v-if="mode !== 'atBat' && currentAngle === 'pitcher'"
                    class="setting active"
                    @click="togglePitcherPanel()"
                >
                    投手設定
                </p>
                <!-- <p class="setting" v-else-if="mode !== 'atBat'">投手設定</p> -->
            </div>
        </div>
        <!-- </v-touch> -->
    </div>
</template>

<script>
export default {
    name: 'ThreeRight',
    props: ['mode', 'batterPanelState', 'pitcherPanelState', 'currentAngle'],
    emits: ['set-view-point-and-single-pitch','set-view-point-and-multi-pitch','open-batter-panel', 'close-batter-panel', 'open-pitcher-panel', 'close-pitcher-panel'],
    methods: {
        setViewPointAndSinglePitch: function (cx, cy, cz, lx, ly, lz, angle) {
            console.log('setViewPointAndSinglePitch', cx, cy, cz, lx, ly,)
            this.$emit('set-view-point-and-single-pitch', cx, cy, cz, lx, ly, lz, angle)
        },
        setViewPointAndMultiPitch: function (cx, cy, cz, lx, ly, lz, angle) {
            console.log('setViewPointAndMultiPitch', cx, cy, cz, lx, ly,)
            this.$emit('set-view-point-and-multi-pitch', cx, cy, cz, lx, ly, lz, angle)
        },
        invalidPinch: function (e) {
            e.preventDefault()
        },
        toggleBatterPanel: function () {
            if (this.batterPanelState === false) {
                this.$emit('open-batter-panel')
            } else {
                this.$emit('close-batter-panel')
            }
        },
        togglePitcherPanel: function () {
            if (this.pitcherPanelState === false) {
                this.$emit('open-pitcher-panel')
            } else {
                this.$emit('close-pitcher-panel')
            }
        }
    }
}
</script>

<style scoped>
.three-right {
    position: absolute;
    top: 45px;
    right: 0;
    z-index: 2;
}

.rightBody {
    background: rgba(41, 41, 41, 0.85);
    width: 74px;
    /*  height: 723px;*/
    height: calc(100vh - 45px);
    padding: 10px 7px;
}

.viewPoint {
    color: #fff;
    line-height: 60px;
    width: 60px;
    text-align: center;
    margin: 0;
    height: 60px;
    opacity: 0.5;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.viewPoint.styleSelectedView {
    opacity: 1;
}

.viewPoint span {
    font-size: 60px;
}

.setting {
    width: 60px;
    height: 35px;
    line-height: 35px;
    color: #999999;
    margin: 5px 0;
    text-align: center;
    font-size: 12px;
}

.setting.active {
    color: #ffffff;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}
</style>
